export const CMT_MEMBER = "member";
export const CMT_MEMBER_STORE = "member-in-store";
export const CMT_GUEST = "guest";
export const CMT_GUEST_STORE = "guest-in-store";
